import { z } from "zod";
export const opaqueIdSchema = z
    .string()
    .regex(/^[0-9A-HJKMNP-TV-Z]{26}$/i, "Expected an opaque ULID");
export const opaqueCursorSchema = z.string().trim().min(1).max(512);
export const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/i, "Expected a SHA-256 digest");
//# sourceMappingURL=opaque.js.map